/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_DescriptionInputs */

const en_admin_payments_description = /** @type {(inputs: Admin_Payments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all payment orders`)
};

/**
* | output |
* | --- |
* | "View all payment orders" |
*
* @param {Admin_Payments_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_description = /** @type {((inputs?: Admin_Payments_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_description(inputs)
});
export { admin_payments_description as "admin.payments.description" }